export function Twitter() {
  return (
    <span className="anticon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        id="Layer_1"
        data-name="Layer 1"
        viewBox="0 0 64 64"
        width="64"
        height="64"
      >
        <title>{'icon-tw'}</title>
        <path
          d="M0,57.33V6.66A6.69,6.69,0,0,1,6.67,0H57.35A6.69,6.69,0,0,1,64,6.66V57.33A6.69,6.69,0,0,1,57.35,64H6.67A6.69,6.69,0,0,1,0,57.33ZM51.09,25c0-.41,0-.83,0-1.24a19.57,19.57,0,0,0,4.77-4.95,18.83,18.83,0,0,1-5.49,1.5A9.58,9.58,0,0,0,54.54,15a19.06,19.06,0,0,1-6.07,2.32,9.57,9.57,0,0,0-16.29,8.72,27.14,27.14,0,0,1-19.71-10,9.57,9.57,0,0,0,3,12.76,9.45,9.45,0,0,1-4.33-1.19s0,.07,0,.12a9.56,9.56,0,0,0,7.67,9.38,9.83,9.83,0,0,1-2.52.33,9.36,9.36,0,0,1-1.8-.17,9.57,9.57,0,0,0,8.93,6.64A19.2,19.2,0,0,1,11.51,48a19.55,19.55,0,0,1-2.28-.14,27,27,0,0,0,14.66,4.3C41.47,52.19,51.09,37.62,51.09,25Z"
          fill="currentcolor"
        />
      </svg>
    </span>
  );
}
